import React, { Component } from "react";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";

import Divider from "@material-ui/core/Divider";
import { Cookies } from "react-cookie";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import { Alert } from "@material-ui/lab";
import * as constants from "../constants";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Container from "@material-ui/core/Container";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";
import { PieChart, Pie, Cell } from "recharts";
import RequestBoxes from "./Box/RequestBoxes";
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
} from 'recharts';
const COLORS = [
  "#fe00FE",
  "#00C49F",
  "#FFBB28",
  "#FF8042",
  "#44b722",
  "#aaad50",
  "#4e3700",
  "#0a0a0a",
  "#feccFE",
  "#aaC49F",
  "#F0B020",
  "#FF8042",
  "#fe00FE",
  "#00C49F",
  "#FFBB28",
  "#FF8042",
  "#44b722",
  "#aaad50",
  "#4e3700",
  "#0a0a0a",
  "#feccFE",
  "#aaC49F",
  "#F0B020",
  "#FF8042",
  "#fe00FE",
  "#00C49F",
  "#FFBB28",
  "#FF8042",
  "#44b722",
  "#aaad50",
  "#4e3700",
  "#0a0a0a",
  "#feccFE",
  "#aaC49F",
  "#F0B020",
  "#FF8042",
];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
                                 cx,
                                 cy,
                                 midAngle,
                                 innerRadius,
                                 outerRadius,
                                 percent,
                                 index,
                               }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.8;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  return percent !== 0 ? (
      <text
          x={x}
          y={y}
          fill="white"
          textAnchor={x > cx ? "start" : "end"}
          dominantBaseline="central"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
  ) : null;
};

const styles = (theme) => ({
  paperrtl: {
    marginTop: theme.spacing(0),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  paper: {
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(1),
      width: theme.spacing(20),
    },
  },
});

class Home extends Component {
  cookies = new Cookies();
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      snackstr: "",
      showSnack: false,
      snackMode: "success",
      dataChart2Visible: 5, // تعداد ردیف اولیه برای نمایش
      showAllDataChart2: false,
      dataChartState2Visible: 5,
      showAllDataChartState2: false,
      dataChartState3Visible: 5,
      showAllDataChartState3: false,
      requestCounts: {}, // 👈 این
      agentPermision: [],
      rowsPerPage2: 5,
      page2: 0,
      dataChart2: [],
      dataChart: [],
      dataChartState2: [],
      dataChartState3: [],
      dataChartState: [],
      tempStaus2: [],
      openGroup: null,   // گروه باز شده
      requestCounts2: {}, // داده‌ها از getOrder2()
      selectedGroup: null, // گروه انتخاب شده برای نمودار
      chartDataForGroup: [], // داده‌ی نمودار برای گروه انتخاب شده
    };
  }

  toggleMoreDataChart2 = () => {
    this.setState((prevState) => ({
      showAllDataChart2: !prevState.showAllDataChart2,
      dataChart2Visible: prevState.showAllDataChart2
          ? 5
          : prevState.dataChart2.length,
    }));
  };

  toggleMoreDataChartState2 = () => {
    this.setState((prevState) => ({
      showAllDataChartState2: !prevState.showAllDataChartState2,
      dataChartState2Visible: prevState.showAllDataChartState2
          ? 5
          : prevState.dataChartState2.length,
    }));
  };

  toggleMoreDataChartState3 = () => {
    this.setState((prevState) => ({
      showAllDataChartState3: !prevState.showAllDataChartState3,
      dataChartState3Visible: prevState.showAllDataChartState3
          ? 5
          : prevState.dataChartState3.length,
    }));
  };

  componentDidMount() {
    if (this.cookies.get("employee_token_str")) {
      this.props.props.dispatch({
        type: "WAITSHOW",
      })

      var self = this
      var xhttp = new XMLHttpRequest()
      xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {
          var arr = JSON.parse(this.responseText)
          if (arr.result === "ok") {
            self.handleGetReq()
            self.getOrder()
            self.getOrder2()
            self.getPermisionAgent()

          } else if (arr.result === "error") {
            self.setState({ redirect: true })
          }
          self.props.props.dispatch({
            type: "WITEHIDE",
          })
        }
      }
      var fd = new FormData()
      fd.append("command", "checkemployeelogin")

      xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
      xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
      xhttp.send(fd)
    } else {
      this.setState({ redirect: true })
    }
  }




  handleGetReq = () => {

    this.props.dispatch({
      type: "WAITSHOW",
    });

    var self = this;
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
      if (this.readyState === 4 && this.status === 200) {
        var arr = JSON.parse(this.responseText);
        if (arr.result === "ok") {

          console.log('arr',arr)
          self.setState({
            requestCounts: arr.data, // 👈 این مهمه
          });

        } else if (arr.result === "error") {
          // در صورت خطا، هیچ عملی انجام نمی‌دهیم
        }

        // self.props.props.props.dispatch({
        //   type: "WITEHIDE",
        // });

      }
    };

    var fd = new FormData();

    xhttp.open("POST", `${constants.BASE_URL}/Home/GetReq`);
    xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"));
    xhttp.send(fd);
  };




  getPermisionAgent() {
    this.props.props.dispatch({
      type: "WAITSHOW",
    });
    var self = this;
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        console.log(this.responseText);
        var arr = JSON.parse(this.responseText);
        console.log(arr);
        if (arr.result === "ok") {
          var i,
              j,
              temp,
              temparray = [];
          for (i = 0; i < arr.data1.length; i++) {
            temp = {
              entity_desc: arr.data1[i].permision_entity_desc,
              entity_name: arr.data1[i].permision_entity_name,
              new: false,
              view: false,
              modify: false,
              delete: false,
            };
            temparray.push(temp);
          }
          console.log(temparray);
          var exist;

          for (j = 0; j < temparray.length; j++) {
            exist = 0;
            for (i = 0; i < arr.data.length; i++) {
              if (
                  arr.data[i].emloyee_permision_entity ===
                  temparray[j].entity_name
              ) {
                if (arr.data[i].emloyee_permision_mode === "new") {
                  temparray[j].new = true;
                  exist = 1;
                } else if (arr.data[i].emloyee_permision_mode === "modify") {
                  temparray[j].modify = true;
                  exist = 1;
                } else if (arr.data[i].emloyee_permision_mode === "view") {
                  temparray[j].view = true;
                  exist = 1;
                } else if (arr.data[i].emloyee_permision_mode === "delete") {
                  temparray[j].delete = true;
                  exist = 1;
                }
              }
            }
            //temparray.splice(j, 1);
          }

          self.setState(
              {
                agentPermision: temparray,
              },
              () => {}
          );
        } else if (arr.result === "error") {
        }
        self.props.props.dispatch({
          type: "WITEHIDE",
        });
      }
    };
    var fd = new FormData();
    fd.append("command", "get_employee_permission");
    fd.append(
        "filter1",
        "emloyee_permision_emloyee_id=" + this.cookies.get("employee_id")
    );

    xhttp.open("POST", `${constants.BASE_URL}/employee`);
    xhttp.setRequestHeader(
        "Authorization",
        this.cookies.get("employee_token_str")
    );
    xhttp.send(fd);
  }

  handleChangeRowsPerPage2 = (event) => {
    this.setState({ rowsPerPage2: parseInt(event.target.value), page2: 0 });
  };

  handleChangePage2 = (event, number) => {
    this.setState({ page2: parseInt(number, 0) });
  };

  handleClickcloseTasckBar = (event) => {
    this.setState({ showSnack: false });
  };

  gotoDetailRequest = (Request) => {
    this.props.props.dispatch({
      type: "STATEREQUEST",
      state: Request,
    });
  };

  changeStatuse = () => {
    if (this.cookies.get("employee_token_str")) {
    } else {
    }
  };

  updateChartState = (event) => {
    const { dataChartState, requestinfofilter } = this.state;
    var i,
        j,
        temp,
        temparray1 = dataChartState,
        cnt = 0;

    for (j = 0; j < temparray1.length; j++) {
      temp = 0;
      for (i = 0; i < requestinfofilter.length; i++) {
        if (temparray1[j].name === requestinfofilter[i].request_last_state_id) {
          temp++;
        }
      }
      temparray1[j].value = temp;
      cnt += temp;
    }
    for (j = 0; j < temparray1.length; j++) {
      temparray1[j].percentValue = ((temparray1[j].value / cnt) * 100).toFixed(
          0
      );
    }

    this.setState({ dataChartState2: temparray1 });
  };

  updateChartCompany = (event) => {
    const { dataChartState, requestinfofilter } = this.state;
    var i,
        j,
        temp,
        temparray1 = dataChartState,
        cnt = 0;

    for (j = 0; j < temparray1.length; j++) {
      temp = 0;
      for (i = 0; i < requestinfofilter.length; i++) {
        if (temparray1[j].name === requestinfofilter[i].request_company_id) {
          temp++;
        }
      }
      temparray1[j].value = temp;
      cnt += temp;
    }
    for (j = 0; j < temparray1.length; j++) {
      temparray1[j].percentValue = ((temparray1[j].value / cnt) * 100).toFixed(
          0
      );
    }

    this.setState({ dataChartState3: temparray1 });
  };

  updateChart = (event) => {
    const { dataChart, requestinfofilter } = this.state;

    console.log("requestinfofilter",requestinfofilter)
    var i,
        j,
        temp,
        temparray1 = dataChart,
        cnt = 0;

    for (j = 0; j < temparray1.length; j++) {
      temp = 0;
      for (i = 0; i < requestinfofilter.length; i++) {
        if (
            temparray1[j].name ===
            requestinfofilter[i].request_fieldinsurance_fa
                .replace("بیمه", "")
                .replace("های", "")
        ) {
          temp++;
        }
      }
      temparray1[j].value = temp;
      cnt += temp;
    }
    for (j = 0; j < temparray1.length; j++) {
      temparray1[j].percentValue = ((temparray1[j].value / cnt) * 100).toFixed(
          0
      );
    }

    this.setState({ dataChart2: temparray1 });
  };

  getOrder() {
    this.props.props.dispatch({
      type: "WAITSHOW",
    });
    var self = this;
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        var arr = JSON.parse(this.responseText);
        console.log(arr);
        if (arr.result === "ok") {
          var i,
              tempStaus2 = [],
              tempStaus3 = [],
              tempStaus9 = [],
              tempStaus10 = [];
          for (i = 0; i < arr.data.length; i++) {
            if (arr.data[i].request_last_state_id === "2") {
              tempStaus2.push(arr.data[i]);
            } else if (arr.data[i].request_last_state_id === "3") {
              tempStaus3.push(arr.data[i]);
            } else if (arr.data[i].request_last_state_id === "9") {
              tempStaus9.push(arr.data[i]);
            } else if (arr.data[i].request_last_state_id === "10") {
              tempStaus10.push(arr.data[i]);
            }
          }
          self.setState(
              {
                tempStaus2: tempStaus2,
                tempStaus3: tempStaus3,
                tempStaus9: tempStaus9,
                tempStaus10: tempStaus10,
                requestinfos: arr.data,
                requestinfofilter: arr.data,
              },
              () => {
                self.getFieldInsurance();
                self.getState();
                self.getCompany();
              }
          );
        } else if (arr.result === "error") {
        }
        self.props.props.dispatch({
          type: "WITEHIDE",
        });
      }
    };
    var fd = new FormData();
    fd.append("command", "get_request_nodetail");

    xhttp.open("POST", `${constants.BASE_URL}/Employeerequestreport`);
    xhttp.setRequestHeader(
        "Authorization",
        this.cookies.get("employee_token_str")
    );
    xhttp.send(fd);
  }

  getOrder2() {
    this.props.props.dispatch({ type: "WAITSHOW" });
    var self = this;
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        var arr = JSON.parse(this.responseText);
        console.log(arr);
        if (arr.result === "ok") {
          self.setState({ requestCounts2: arr.data });
        }
        self.props.props.dispatch({ type: "WITEHIDE" });
      }
    };
    var fd = new FormData();
    fd.append("command", "get_groups");

    xhttp.open("POST", `${constants.BASE_URL}/Employeerequestreport`);
    xhttp.setRequestHeader(
        "Authorization",
        this.cookies.get("employee_token_str")
    );
    xhttp.send(fd);
  }

  normalize = (str) => {
    return str.replace(/[\u200C]/g, " ")
        .replace(/\s+/g, " ")
        .trim();
  }

  toggleGroup = (groupName) => {
    const { requestCounts2, dataChart } = this.state;

    const items = requestCounts2[groupName];
    if (!items || items.length === 0) return;

    // 1️⃣ ساخت دیتا برای گروه با value واقعی
    const chartDataForGroup = items.map(item => {
      // حذف "بیمه" از اول اسم برای مطابقت بهتر
      const searchName = this.normalize(item.fieldinsurance_fa.replace(/^بیمه\s*/g, ""));

      // پیدا کردن در dataChart
      const found = dataChart.find(x => this.normalize(x.name) === searchName);

      return {
        name: item.fieldinsurance_fa,
        value: found ? found.value : 0
      };
    });

    // 2️⃣ محاسبه مجموع value کل گروه
    const totalForGroup = chartDataForGroup.reduce((sum, x) => sum + x.value, 0);

    // 3️⃣ محاسبه درصد هر آیتم نسبت به مجموع گروه
    const finalChartData = chartDataForGroup.map(x => ({
      name: x.name,
      value: x.value,
      percent: totalForGroup === 0 ? 0 : Math.round((x.value / totalForGroup) * 100)
    }));

    // 4️⃣ آپدیت state
    this.setState({
      openGroup: groupName,
      selectedGroup: groupName,
      chartDataForGroup: finalChartData
    });

    console.log("Group chart data:", finalChartData);
  };




  getFieldInsurance() {
    this.props.props.dispatch({
      type: "WAITSHOW",
    });
    var self = this;
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        var arr = JSON.parse(this.responseText);
        console.log(arr);
        if (arr.result === "ok") {
          var i,
              temp,
              temparray = [];
          for (i = 0; i < arr.data.length; i++) {
            temp = {
              name: arr.data[i].fieldinsurance_fa
                  .replace("بیمه", "")
                  .replace("های", ""),
              value: 0,
              color: COLORS[i],
              percentValue: 0,
            };
            temparray.push(temp);
          }
          self.setState({ dataChart: temparray }, () => {
            self.updateChart();
          });
        } else if (arr.result === "error") {
        }
        self.props.props.dispatch({
          type: "WITEHIDE",
        });
      }
    };
    var fd = new FormData();
    fd.append("command", "get_fieldinsurance");
    xhttp.open("POST", `${constants.BASE_URL}/agentrequestreport`);

    xhttp.send(fd);
  }

  getState() {
    this.props.props.dispatch({
      type: "WAITSHOW",
    });
    var self = this;
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        var arr = JSON.parse(this.responseText);
        console.log(arr);
        if (arr.result === "ok") {
          var i,
              temp,
              temparray = [],
              j = 0;
          for (i = 0; i < arr.data.length; i++) {
            if (
                arr.data[i].request_state_id !== "1" &&
                arr.data[i].request_state_id !== "12"
            ) {
              temp = {
                name: arr.data[i].request_state_id,
                stateName: arr.data[i].request_state_name,
                value: 0,
                color: COLORS[j],
                percentValue: 0,
              };
              j++;
              temparray.push(temp);
            }
          }
          self.setState({ dataChartState: temparray }, () => {
            self.updateChartState();
          });
        } else if (arr.result === "error") {
        }
        self.props.props.dispatch({
          type: "WITEHIDE",
        });
      }
    };
    var fd = new FormData();
    fd.append("command", "getstaterequest");
    xhttp.open("POST", `${constants.BASE_URL}/agentrequestreport`);

    xhttp.send(fd);
  }

  getCompany() {
    this.props.props.dispatch({
      type: "WAITSHOW",
    });
    var self = this;
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        var arr = JSON.parse(this.responseText);
        console.log(arr);
        if (arr.result === "ok") {
          var i,
              temp,
              temparray = [],
              j = 0;
          for (i = 0; i < arr.data.length; i++) {
            temp = {
              name: arr.data[i].company_id,
              stateName: arr.data[i].company_name,
              value: 0,
              color: COLORS[j],
              percentValue: 0,
            };
            j++;
            temparray.push(temp);
          }
          self.setState({ dataChartState: temparray }, () => {
            self.updateChartCompany();
          });
        } else if (arr.result === "error") {
        }
        self.props.props.dispatch({
          type: "WITEHIDE",
        });
      }
    };
    var fd = new FormData();
    fd.append("command", "get_company");
    xhttp.open("POST", `${constants.BASE_URL}/company`);

    xhttp.send(fd);
  }




  render() {
    const { classes } = this.props;
    const {
      agentPermision,
      dataChart2Visible,
      showAllDataChart2,
      dataChartState2Visible,
      showAllDataChartState2,
      dataChartState3Visible,
      showAllDataChartState3,
      snackMode,
      snackstr,
      showSnack,
      rowsPerPage2,
      page2,
      dataChart2,
      dataChartState2,
      dataChartState3,
      requestCounts,
      openGroup,
      requestCounts2,
      selectedGroup,
      chartDataForGroup,
      chartDataForGroupFinal,
    } = this.state;
    //    const {  employee_id,employee_gender,employee_name,employee_family,employee_image} =  this.props.employeeProperty;
    const { employee_id } = this.props.employeeProperty;

    return (
        <div>
          <Container>
            {employee_id === null ? null : (
                <div>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>

                      <RequestBoxes data={requestCounts} />
                    </Grid>

                    <Container>
                      <h2>لیست گروه‌ها و بیمه‌ها</h2>
                      <div className="space-y-2">
                        {Object.entries(requestCounts2).map(([groupName, items]) => (
                            <div key={groupName} style={{ border: "1px solid #ccc", marginBottom: 8, borderRadius: 4 }}>
                              {/* دکمه گروه */}
                              <button
                                  onClick={() => this.toggleGroup(groupName)}
                                  style={{
                                    width: "100%",
                                    textAlign: "right",
                                    fontWeight: "bold",
                                    padding: "8px",
                                    background: "#f0f0f0",
                                    cursor: "pointer",
                                    border: "none",
                                    borderRadius: "4px",
                                  }}
                              >
                                {groupName}
                              </button>

                              {/* جدول زیر گروه */}
                              {openGroup === groupName && (
                                  <table style={{ width: "100%", marginTop: 8, borderCollapse: "collapse" }}>
                                    <thead>
                                    <tr>
                                      <th style={{ border: "1px solid #ccc", padding: 4 }}>ID</th>
                                      <th style={{ border: "1px solid #ccc", padding: 4 }}>Name EN</th>
                                      <th style={{ border: "1px solid #ccc", padding: 4 }}>Name FA</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {items.map((item) => (
                                        <tr key={item.fieldinsurance_id}>
                                          <td style={{ border: "1px solid #ccc", padding: 4 }}>{item.fieldinsurance_id}</td>
                                          <td style={{ border: "1px solid #ccc", padding: 4 }}>{item.fieldinsurance}</td>
                                          <td style={{ border: "1px solid #ccc", padding: 4 }}>{item.fieldinsurance_fa}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                  </table>
                              )}
                            </div>
                        ))}
                      </div>

                      {selectedGroup && chartDataForGroup.length > 0 && (
                          <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
                            <BarChart
                                width={500}
                                height={300}
                                data={chartDataForGroup}
                                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                            >
                              <CartesianGrid strokeDasharray="3 3" />
                              <XAxis dataKey="name" />
                              <YAxis />
                              <Tooltip formatter={(value, name, props) => [`${value} (${props.payload.percent}%)`, name]} />
                              <Bar dataKey="value" fill="#8884d8">
                                {chartDataForGroup.map((entry, index) => (
                                    <Cell key={`cell-${index}`} />
                                ))}
                              </Bar>
                            </BarChart>
                          </div>
                      )}






                    </Container>


                    <Grid item xs={12} sm={6}>

                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Paper className={classes.root}></Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <div dir="rtl" style={{ width: "100%", textAlign: "center" }}>
                        <PieChart width={250} height={250}>
                          <Pie
                              dataKey="name"
                              isAnimationActive={false}
                              data={dataChart2}
                              cx={0}
                              cy={0}
                              outerRadius={230}
                              fill="#8884d8"
                              label
                          />

                          <Pie
                              data={dataChart2}
                              cx={120}
                              cy={120}
                              labelLine={false}
                              label={renderCustomizedLabel}
                              outerRadius={120}
                              fill="#8884d8"
                              dataKey="value"
                          >
                            {dataChart2.map((entry, index) => (
                                <Cell
                                    key={`cell-${index}`}
                                    fill={COLORS[index % COLORS.length]}
                                />
                            ))}
                          </Pie>
                        </PieChart>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TableContainer component={Paper}>
                        <Table className={classes.table} aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell align="center">رشته بیمه</TableCell>
                              <TableCell align="center">تعداد</TableCell>
                              <TableCell align="center">رنگ نمودار</TableCell>
                              <TableCell align="center">درصد</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {dataChart2.slice(0, dataChart2Visible).map((row) => (
                                <TableRow key={row.name}>
                                  <TableCell align="center">{row.name}</TableCell>
                                  <TableCell align="center">{row.value}</TableCell>
                                  <TableCell align="center">
                                    <Button
                                        variant="contained"
                                        style={{ background: row.color }}
                                    />
                                  </TableCell>
                                  <TableCell align="center">{row.percentValue}</TableCell>
                                </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>

                      {dataChart2.length > 5 && (
                          <Button
                              variant="outlined"
                              onClick={this.toggleMoreDataChart2}
                              style={{ marginTop: "10px" }}
                          >
                            {showAllDataChart2 ? "Less" : "More"}
                          </Button>
                      )}
                    </Grid>


                    <Grid item xs={12}>
                      <Divider />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <div dir="rtl" style={{ width: "100%", textAlign: "center" }}>
                        <PieChart width={250} height={250}>
                          <Pie
                              dataKey="name"
                              isAnimationActive={false}
                              data={dataChartState2}
                              cx={0}
                              cy={0}
                              outerRadius={230}
                              fill="#8884d8"
                              label
                          />

                          <Pie
                              data={dataChartState2}
                              cx={120}
                              cy={120}
                              labelLine={false}
                              label={renderCustomizedLabel}
                              outerRadius={120}
                              fill="#8884d8"
                              dataKey="value"
                          >
                            {dataChartState2.map((entry, index) => (
                                <Cell
                                    key={`cell-${index}`}
                                    fill={COLORS[index % COLORS.length]}
                                />
                            ))}
                          </Pie>
                        </PieChart>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TableContainer component={Paper}>
                        <Table className={classes.table} aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell align="center">وضعیت سفارش </TableCell>
                              <TableCell align="center">تعداد</TableCell>
                              <TableCell align="center">رنگ نمودار</TableCell>
                              <TableCell align="center">درصد</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {dataChartState2
                                .slice(0, dataChartState2Visible)
                                .map((row) => (
                                    <TableRow key={row.name}>
                                      <TableCell align="center">{row.stateName}</TableCell>
                                      <TableCell align="center">{row.value}</TableCell>
                                      <TableCell align="center">
                                        <Button
                                            variant="contained"
                                            style={{ background: row.color }}
                                        />
                                      </TableCell>
                                      <TableCell align="center">{row.percentValue}</TableCell>
                                    </TableRow>
                                ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      {dataChartState2.length > 5 && (
                          <Button
                              variant="outlined"
                              onClick={this.toggleMoreDataChartState2}
                              style={{ marginTop: "10px" }}
                          >
                            {showAllDataChartState2 ? "Less" : "More"}
                          </Button>
                      )}
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <div dir="rtl" style={{ width: "100%", textAlign: "center" }}>
                        <PieChart width={250} height={250}>
                          <Pie
                              dataKey="name"
                              isAnimationActive={false}
                              data={dataChartState3}
                              cx={0}
                              cy={0}
                              outerRadius={230}
                              fill="#8884d8"
                              label
                          />

                          <Pie
                              data={dataChartState3}
                              cx={120}
                              cy={120}
                              labelLine={false}
                              label={renderCustomizedLabel}
                              outerRadius={120}
                              fill="#8884d8"
                              dataKey="value"
                          >
                            {dataChartState3.map((entry, index) => (
                                <Cell
                                    key={`cell-${index}`}
                                    fill={COLORS[index % COLORS.length]}
                                />
                            ))}
                          </Pie>
                        </PieChart>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TableContainer component={Paper}>
                        <Table className={classes.table} aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell align="center">شرکت بیمه </TableCell>
                              <TableCell align="center">تعداد</TableCell>
                              <TableCell align="center">رنگ نمودار</TableCell>
                              <TableCell align="center">درصد</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {dataChartState3
                                .slice(0, dataChartState3Visible)
                                .map((row) => (
                                    <TableRow key={row.name}>
                                      <TableCell align="center">{row.stateName}</TableCell>
                                      <TableCell align="center">{row.value}</TableCell>
                                      <TableCell align="center">
                                        <Button
                                            variant="contained"
                                            style={{ background: row.color }}
                                        />
                                      </TableCell>
                                      <TableCell align="center">{row.percentValue}</TableCell>
                                    </TableRow>
                                ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      {dataChartState3.length > 5 && (
                          <Button
                              variant="outlined"
                              onClick={this.toggleMoreDataChartState3}
                              style={{ marginTop: "10px" }}
                          >
                            {showAllDataChartState3 ? "Less" : "More"}
                          </Button>
                      )}
                    </Grid>
                  </Grid>

                  <Snackbar
                      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                      onClose={this.handleClickcloseTasckBar}
                      open={showSnack}
                      autoHideDuration={10000}
                  >
                    <Alert severity={snackMode}>{snackstr}</Alert>
                  </Snackbar>
                </div>
            )}
          </Container>
        </div>
    );
  }
}

const mapStateToPropsAppContainer = (state) => {
  return {
    employeeProperty: state.employeeProperty.employeeProperty,
  };
};

export default withStyles(styles)(connect(mapStateToPropsAppContainer)(Home));
